// ProductDetailList.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import MessageCard from '../container/MessageCard.js';

import {
  InfiniteScroller,
  ScrollItem,
} from '../component/InfiniteScroller.jsx';
import Loading from '../component/Loading.jsx';

import {
  searchStoryMessageCardWidth,
  searchStoryMessageCardWidthTablet,
  searchStoryMessageCardWidthMobile,
  searchStoryMessageCardsColumnGap,
} from '../style/variables.js';
import media from '../style/media.js';

export const ProductDetailList = ({
  feedName,
  nextPage,
  isNextPageFetching,
  messageIds,
  listSelectPath,
  nextPageError,
  fetchFeeds,
}) => {
  return (
    <InfiniteScroller
      pageStart={1}
      hasMore={nextPage != null && nextPageError == null}
      loadMore={() => {
        fetchFeeds({
          type: feedName,
          page: nextPage,
        });
      }}
      isFetching={isNextPageFetching}
      threshold={100}
      useWindow
    >
      <MessagesList>
        <ScrollItem
          loader={
            <MessageCardWrapper>
              <Loading />
            </MessageCardWrapper>
          }
        >
          {messageIds.map((messageId, index) => (
            <MessageCardWrapper key={messageId}>
              <MessageCard
                id={messageId}
                categoryIndex={index}
                categoryId={feedName}
                itemIndexInCategory={index}
                listPath={listSelectPath}
                shouldWrapLink
                shouldShowUser
                shouldTrackEvent
                shouldShowTooltip
              />
            </MessageCardWrapper>
          ))}
        </ScrollItem>
      </MessagesList>
    </InfiniteScroller>
  );
};

ProductDetailList.propTypes = {
  feedName: PropTypes.string,
  isNextPageFetching: PropTypes.bool,
  listSelectPath: PropTypes.array,
  messageIds: PropTypes.array,
  nextPage: PropTypes.number,
  nextPageError: PropTypes.object,
  fetchFeeds: PropTypes.func,
};

ProductDetailList.defaultProps = {
  feedName: null,
  isNextPageFetching: false,
  listSelectPath: [],
  messageIds: [],
  nextPage: null,
  nextPageError: null,
  fetchFeeds: () => null,
};

const MessagesList = styled.div`
  padding: 32px 20px;
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(${searchStoryMessageCardWidth}px, 1fr)
  );
  gap: ${searchStoryMessageCardsColumnGap}px;
  ${media.tablet`
    padding: 32px 8px;
    grid-template-columns: repeat(
      auto-fill,
      minmax(${searchStoryMessageCardWidthTablet}px, 1fr)
    );
  `};
  ${media.mobile`
    padding: 16px;
    grid-template-columns: repeat(
      auto-fill,
      minmax(${searchStoryMessageCardWidthMobile}px, 1fr)
    );
  `};
`;

const MessageCardWrapper = styled.div`
  aspect-ratio: 148/196;
`;

export default ProductDetailList;
